import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getBankAccountDetails = (
  id: number | undefined,
  signal?: AbortSignal
) => {
  return axiosPrivate.get(`/dashboard/v2/bank-accounts`, {
    params: {
      accountId: id,
    },
    signal,
  });
};
